import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=2c1bf203"
import script from "./HeaderTitle.vue?vue&type=script&lang=ts"
export * from "./HeaderTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports